<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="d-flex align-item-center" style="gap:10px">
        <div class="section-title" style="line-height:1.4;">Image Gallery</div>

        <div>
          <b-form-input
            v-debounce:1000="getGalleryImages"
            v-model="searchValue"
            placeholder="Search..."
          ></b-form-input>
        </div>
      </div>

      <div class="d-flex align-item-center">
        <button class="btn-blue" v-b-modal.addImage>Add Image</button>

        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div class="page-container overflow-hidden rounded pt-0">
      <div class="row">
        <div class="data-listing-table image-gallery-table">
          <table>
            <thead>
              <tr>
                <th>Image</th>
                <th>File Name</th>
                <th>Description</th>
                <th>Category</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody v-if="images_list.length > 0">
              <tr
                v-for="(img, imgIndex) in images_list"
                :key="imgIndex"
                class="light_grey_back"
              >
                <td>
                  <div class="image-placeholder">
                    <!-- <img src="@/assets/img/temp/movie.jpg" /> -->
                    <img :src="`${img.base_url}${img.image_path}`" />
                  </div>
                </td>
                <!-- <td>John Wick Chapter 3</td> -->
                <td>{{ img.image_name ? img.image_name : "-" }}</td>
                <td>
                  {{ img.image_description ? img.image_description : "-" }}
                </td>
                <!-- <td>Movie Poster (Vertical)</td> -->
                <td>{{ img.category ? img.category : "-" }}</td>

                <td>
                  <button
                    @click="getImageDetails(img.image_id)"
                    class="btn-transparent"
                  >
                    Edit
                  </button>
                  <span class="font-weight-light">|</span>
                  <button class="btn-transparent">
                    <span
                      @click="
                        disable_image_id = img.image_id;
                        $bvModal.show('confirmation');
                      "
                      class="text-danger"
                      >Disable</span
                    >
                  </button>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>

    <b-modal
      scrollable
      hide-footer
      size="xl"
      title="Add Image to Gallery"
      id="addImage"
    >
      <div class="col-12">
        <div class="row">
          <div class="col-8 text-center align-self-center">
            <div class="col-10 mx-auto">
              <div v-if="!gallery_image.image_setting_path">
                <label for="galleryImage" class="btn-outline-blue"
                  >Add Image</label
                >
                <p class="text-muted small">
                  Click the Add Image to upload new image to gallery.
                </p>
                <input
                  type="file"
                  v-on:change="setGalleryImage($event)"
                  class="d-none"
                  id="galleryImage"
                />
              </div>
              <div v-else>
                <img
                  v-if="
                    gallery_image.image_setting_path &&
                      gallery_image.image_setting_path.length > 0
                  "
                  :src="_GetImagePath(gallery_image.image_setting_path)"
                  class="img-fluid"
                />
              </div>

              <!-- SHOW IMAGE HERE AFTER UPLOADED -->
              <!-- <div>
              <img src="@/assets/img/temp/movie.jpg" class="image-fluid" />
              <div>
                <button class="btn-outline-blue m-3">Edit Image</button>
              </div>
              </div>-->
            </div>
          </div>
          <div class="col-4 border-left">
            <div class="row">
              <div class="col-12 mb-4">
                <div class="input-material">
                  <input v-model="image_name" type="text" placeholder="." />
                  <label>Image Name</label>
                </div>
              </div>

              <div class="col-12 mb-4">
                <div class="input-material">
                  <input
                    v-model="image_description"
                    type="text"
                    placeholder="."
                  />
                  <label>Description</label>
                </div>
              </div>

              <div class="col-12">
                <b-form-group label="Select Menu">
                  <div
                    class="j-radio pl-0 mb-2"
                    v-for="(menu, menuIndex) in menu_names"
                    :key="menuIndex"
                  >
                    <b-form-radio
                      v-model="selectedMenu"
                      @change="resetCategory($event)"
                      name="some-radios"
                      :value="menu"
                      >{{ menu }}</b-form-radio
                    >
                  </div>

                  <!-- <div class="j-radio pl-0 mb-2">
                  <b-form-radio v-model="selectedMenu" name="some-radios" value="B">Movie banners</b-form-radio>
                </div>

                <div class="j-radio pl-0 mb-2">
                  <b-form-radio v-model="selectedMenu" name="some-radios" value="C">Movie poster</b-form-radio>
                  </div>-->
                </b-form-group>
              </div>

              <div
                v-if="categories && categories.length > 0"
                class="col-12 mb-4"
              >
                <div class="dropdown-curve-container">
                  <label
                    :class="
                      selected_category && selected_category.length > 0
                        ? 'shift-up'
                        : ''
                    "
                    >Select Category</label
                  >
                  <b-dropdown
                    variant="dropdown-curve"
                    :text="selected_category"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-on:click="selectCategory($event, category)"
                      v-for="(category, categoryIndex) in categories"
                      :key="categoryIndex"
                      >{{ category }}</b-dropdown-item
                    >
                    <!-- <b-dropdown-item>Second Action</b-dropdown-item>
                    <b-dropdown-item>Third Action</b-dropdown-item>-->
                    <!-- <b-dropdown-divider></b-dropdown-divider> -->
                  </b-dropdown>
                </div>
              </div>

              <div class="col-12 mb-4">
                <label class="mb-0">Link:</label>
                <!-- <p class="mb-0">http://localhost/Brij/uploads/2020/04/Faviocn.png</p> -->
                <p class="mb-0">
                  {{
                    gallery_image.image_setting_path
                      ? _GetImagePath(gallery_image.image_setting_path)
                      : "-"
                  }}
                </p>
              </div>

              <div class="col-12 mb-4">
                <p class="mb-0">
                  File Size:
                  <!-- <span class="font-weight-semi-bold">20mb</span> -->
                  <span class="font-weight-semi-bold"
                    >{{ img_details.size ? img_details.size : "0" }} kb</span
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 pt-3 text-center border-top px-0">
            <button @click="$bvModal.hide('addImage')" class="btn-outline-blue">
              Cancel
            </button>
            <span class="mx-1"></span>
            <button @click="submitInfo(1)" class="btn-blue">Save</button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- EDIT IMAGE -->
    <b-modal scrollable hide-header hide-footer size="xl" id="editImage">
      <header class="font-weight-semi-bold mb-4 fs-20">
        Edit Image Details
      </header>
      <button
        class="btn-modal-close btn-modal-close-custom"
        @click="
          $bvModal.hide('editImage');
          resetData();
        "
      >
        <span>&times;</span>
      </button>
      <div class="row">
        <div class="col-8 text-center align-self-center">
          <div class="col-10 mx-auto">
            <!-- <div v-if="!gallery_image.image_setting_path">
              <label for="galleryImage" class="btn-outline-blue">Add Image</label>
              <p class="text-muted small">Click the Add Image to upload new image to gallery.</p>
              <input type="file" v-on:change="setGalleryImage($event)" class="d-none" id="galleryImage" />
            </div>-->
            <div>
              <!--height="720"-->
              <img
                v-if="
                  img_path &&
                    img_path.length > 0 &&
                    base_url &&
                    base_url.length > 0
                "
                :src="`${base_url}${img_path}`"
                height="auto"
                width="480"
                class="rounded c-pointer"
              />
            </div>

            <!-- SHOW IMAGE HERE AFTER UPLOADED -->
            <!-- <div>
              <img src="@/assets/img/temp/movie.jpg" class="image-fluid" />
              <div>
                <button class="btn-outline-blue m-3">Edit Image</button>
              </div>
            </div>-->
          </div>
        </div>
        <div class="col-4 border-left">
          <div class="row">
            <div class="col-12 mb-4">
              <div class="input-material">
                <input v-model="image_name" type="text" placeholder="." />
                <label>Image Name</label>
              </div>
            </div>

            <div class="col-12 mb-4">
              <div class="input-material">
                <input
                  v-model="image_description"
                  type="text"
                  placeholder="."
                />
                <label>Description</label>
              </div>
            </div>

            <div class="col-12">
              <b-form-group label="Select Menu">
                <div
                  class="j-radio pl-0 mb-2"
                  v-for="(menu, menuIndex) in menu_names"
                  :key="menuIndex"
                >
                  <b-form-radio
                    v-model="selectedMenu"
                    @change="resetCategory($event)"
                    name="some-radios"
                    :value="menu"
                    >{{ menu }}</b-form-radio
                  >
                </div>

                <!-- <div class="j-radio pl-0 mb-2">
                  <b-form-radio v-model="selectedMenu" name="some-radios" value="B">Movie banners</b-form-radio>
                </div>

                <div class="j-radio pl-0 mb-2">
                  <b-form-radio v-model="selectedMenu" name="some-radios" value="C">Movie poster</b-form-radio>
                </div>-->
              </b-form-group>
            </div>

            <div v-if="categories && categories.length > 0" class="col-12 mb-4">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    selected_category && selected_category.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >Select Category</label
                >
                <b-dropdown
                  variant="dropdown-curve"
                  :text="selected_category"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-on:click="selectCategory($event, category)"
                    v-for="(category, categoryIndex) in categories"
                    :key="categoryIndex"
                    >{{ category }}</b-dropdown-item
                  >
                  <!-- <b-dropdown-item>Second Action</b-dropdown-item>
                  <b-dropdown-item>Third Action</b-dropdown-item>-->
                  <!-- <b-dropdown-divider></b-dropdown-divider> -->
                </b-dropdown>
              </div>
            </div>

            <div class="col-12 mb-4">
              <label class="mb-0">Link:</label>
              <!-- <p class="mb-0">http://localhost/Brij/uploads/2020/04/Faviocn.png</p> -->
              <p class="mb-0">
                {{
                  img_path &&
                  img_path.length > 0 &&
                  base_url &&
                  base_url.length > 0
                    ? `${base_url}${img_path}`
                    : "-"
                }}
              </p>
            </div>

            <div class="col-12 mb-4">
              <p class="mb-0">
                File Size:
                <!-- <span class="font-weight-semi-bold">20mb</span> -->
                <span class="font-weight-semi-bold"
                  >{{ img_details.size ? img_details.size : "0" }} kb</span
                >
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 pt-3 text-center border-top px-0">
          <button
            @click="
              $bvModal.hide('editImage');
              resetData();
            "
            class="btn-outline-blue"
          >
            Cancel
          </button>
          <span class="mx-1"></span>
          <button @click="submitInfo(2)" class="btn-blue">Update</button>
        </div>
      </div>
    </b-modal>

    <b-modal hide-footer size="xl" title="Select Image">
      <div class="w-100">
        <b-tabs
          content-class="mt-3"
          nav-wrapper-class="nav-tabs-justify-content-center"
        >
          <b-tab title="Upload Image" active>
            <!-- FIRST SECTION WHILE SELECTION -->
            <div
              class="d-flex justify-content-center align-items-center"
              style="min-height: 250px"
            >
              <div>
                <label for="uploadNewImage" class="btn-outline-blue"
                  >Upload Image</label
                >
                <p class="text-muted small"></p>
                <input
                  type="file"
                  v-on:change="setGalleryImage($event)"
                  class="d-none"
                  id="uploadNewImage"
                />
              </div>
            </div>

            <!-- AFTER UPLOAD SHOW BELOW DIV -->
            <!-- <div class="row">
              <div class="col-9">
                <div class="col-6 text-center mx-auto">
                  <img src="@/assets/img/temp/movie.jpg" class="image-fluid" />
                </div>
              </div>
              <div class="col-3 border-left">
                <div class="mb-4">
                  <button class="btn-outline-blue mx-0">Edit Image</button>
                </div>

                <div class="j-checkbox pl-0">
                  <b-form-checkbox value="orange">Save this image in gallery for future use</b-form-checkbox>
                </div>
              </div>
            </div>-->
            <div class="col-6 mx-auto text-center">
              <div class="mt-3"></div>
            </div>
          </b-tab>
          <b-tab title="Image Gallery">
            <div class="row justify-content-center">
              <div
                class="m-3"
                v-for="(images, imgKey) in images_list"
                :key="imgKey"
              >
                <!-- ADD CLASS 'selected' FOR SELECTION -->
                <div class="gallery-image-placeholder">
                  <!-- <img src="@/assets/img/temp/movie.jpg" class="image-fluid" /> -->
                  <img
                    :src="`${images.base_url}${images.image_path}`"
                    class="image-fluid"
                  />
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>

      <footer class="pt-3 border-top text-center mt-3">
        <button class="btn-outline-blue">Cancel</button>
        <span class="mx-1"></span>
        <button class="btn-blue">Confirm</button>
      </footer>
    </b-modal>

    <!-- IMAGE MODAL -->
    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      hide-header
      hide-footer
    >
      <label class="h4 mt-2 mb-4 text-center">{{ tempModalImageName }}</label>
      <button
        class="btn-modal-close"
        @click="$bvModal.hide('selected-image-preview-modal')"
      >
        &times;
      </button>
      <img :src="_GetImagePath(tempModalImagePath)" class="img-fluid" />
    </b-modal>
    <!-- IMAGE CROPPER -->
    <b-modal id="imagecropper" hide-header hide-footer no-close-on-backdrop>
      <!-- <button class="btn-clearDate text-right" v-on:click="hideCropperModal()">✖</button> -->

      <label class="h4 text-center">Crop Image</label>
      <button
        class="btn-clearDate text-right float-right"
        v-on:click="hideCropperModal()"
      >
        ✖
      </button>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :aspect-ratio="width / height"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <br />
      <div class="text-center">
        <button class="btn-blue" @click.prevent.stop="cropImage">Save</button>
      </div>
    </b-modal>

    <b-modal
      id="confirmation"
      title="Disable Image?"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">Are you sure you want to disable this Image?</p>

        <p class="fs-14 mb-4 text-muted">
          <span>
            If you disable, you cannot use this image but places where image
            <br />is already in use will have to be removed manually.
          </span>
        </p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('confirmation')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="disableImage"
        >
          Disable
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import NoRecords from "@/components/Partials/NoRecords";
export default {
  components: { VueCropper, NoRecords },
  data() {
    return {
      disable_image_id: null,
      images_list: [],
      selectedMenu: "",
      gallery_image: {
        image_setting_name: "Gallery Image",
        image_setting_path: null,
        image_setting_static_path: "",
        image_setting_baseurl: "",
        image_setting_showpath: ""
      },
      file: null,
      filename: null,
      width: null,
      height: null,
      cropImg: null,
      tempModalImageName: null,
      tempModalImagePath: null,
      imgSrc: null,
      img_details: {
        height: null,
        width: null,
        size: null
      },
      tempImageName: null,
      galleryId: null,
      menu_names: [
        "Food & Beverages",
        "Movie Banners",
        "Cast & Crew",
        "Cinemas"
      ],
      selected_category: "",
      categories: [],
      image_name: "",
      image_description: "",
      img_path: null,
      base_url: null,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      searchValue: "",
      debounce: null
    };
  },
  mounted() {
    this.getviewingnumber();
    this.getGalleryImages();
  },
  watch: {
    selectedMenu(newval) {
      if (newval == "Food & Beverages") {
        this.categories = ["Veg", "Non Veg"];
        console.log("categories :>> ", this.categories);
      } else if (newval == "Movie Banners") {
        this.categories = ["Movie Banner", "Movie Poster"];
      } else if (newval == "Cast & Crew") {
        this.categories = ["Actor", "Director", "Producer"];
      } else if (newval == "Cinemas") {
        this.categories = ["Cinema Logo"];
      }
      console.log("in here::::::: :>> ");
    }
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getGalleryImages();
      } else {
        this.currentPage = event;
        this.getGalleryImages();
      }
    },
    disableImage() {
      MasterService.DisableImage(this.disable_image_id)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show("Image Disabled");
            this.$bvModal.hide("confirmation");
            this.getGalleryImages();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    resetCategory(event) {
      console.log("event :>> ", event);
      this.selected_category = "";
      // if(event == 'Food & Beverages'){
      //     this.categories = ['Veg', 'Non Veg']
      //     console.log('categories :>> ', this.categories);
      //   }else if(event == 'Movie Banners'){
      //     this.categories = ['Movie Banner','Movie Poster']
      //   }else if(event == 'Cast & Crew'){
      //     this.categories = ['Actor','Director','Producer']
      //   }else if(event == 'Cinemas'){
      //     this.categories = ['Cinema Logo']
      //   }
    },
    getImageDetails(image_id) {
      MasterService.GetImageDetails(image_id)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.selectedMenu = data.Records[0].menu_name;
            this.galleryId = data.Records[0].image_id;
            this.selected_category = data.Records[0].category;
            this.image_name = data.Records[0].image_name;
            this.image_description = data.Records[0].image_description;
            this.img_path = data.Records[0].image_path;
            this.base_url = data.Records[0].base_url;
            this.img_details.height = data.Records[0].image_height;
            this.img_details.width = data.Records[0].image_width;
            this.img_details.size = data.Records[0].image_size;
            this.$bvModal.show("editImage");
          } else {
            this.resetData();
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    resetData() {
      this.selectedMenu = "";
      this.galleryId = null;
      this.selected_category = "";
      this.image_name = "";
      this.image_description = "";
      this.img_details = {
        height: null,
        width: null,
        size: null
      };
    },
    submitInfo(flag) {
      if (this.galleryId) {
        if (
          // this.selectedMenu.length > 0 &&
          // this.selected_category.length > 0 &&
          this.image_name.length > 0
        ) {
          let payload = {
            image_id: this.galleryId,
            menu_name: this.selectedMenu,
            category: this.selected_category,
            image_name: this.image_name,
            image_description:
              this.image_description && this.image_description.length > 0
                ? this.image_description
                : null
          };

          MasterService.UpdateImageDetails(payload)
            .then(response => {
              const { data } = response;
              if (data && data.status) {
                this.getGalleryImages();
                this.$bvModal.hide("addImage");
                this.$bvModal.hide("editImage");
                this.resetData();
                if (flag == 1) this.$toasted.show("Image Added Successfully");
                else this.$toasted.show("Image Updated Successfully");
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        } else {
          this.$toasted.show("Please Enter all details");
        }
      } else {
        this.$toasted.show("Please Upload an Image");
      }
    },
    selectCategory(event, category) {
      this.selected_category = category;
      console.log("this.selected_category :>> ", this.selected_category);
    },
    getGalleryImages: function() {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue
        // searchValue: this.searchValue
      };
      MasterService.GetGalleryImages(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.images_list = data.Records;
            //   if (data.totalRows >= 10) {
            //   this.rows = data.totalRows;
            //   this.selectedvalue = this.selectedvalue < 10 ?  10 : this.selectedvalue

            // } else {
            this.rows = data.totalRows;
            //   this.selectedvalue = data.totalRows;
            // }
          } else {
            this.images_list = [];
            this.rows = 0;
            // this.rows = data.totalRows;
            // this.selectedvalue = data.totalRows;
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    setGalleryImage: function(e) {
      this.file = e.target.files[0];
      this.filename = e.target.files[0]["name"];
      this.tempImageName = e.target.files[0]["name"];
      //   this.indexofthubmnail = PosterIndex;
      //   this.movieindex = MovieContentIndex;

      this.width = 2;
      this.height = 3;

      if (this.file.type.indexOf("image/") === -1) {
        this.$toasted.show("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;

          this.$bvModal.show("imagecropper");
          e.target.value = "";
        };
        reader.readAsDataURL(this.file);
      } else {
        // alert("Sorry, FileReader API not supported");
      }
    },
    ImageData() {
      let temp = this.$refs.cropper.getData(true);
      console.log("temp :>> ", temp);
      let cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      console.log("cropImg :>> ", cropImg);
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      let temp = this.$refs.cropper.getData(true);
      console.log("temp :>> ", temp);
      this.img_details.height = temp.height;
      this.img_details.width = temp.width;
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      //   console.log(this.data);
      var block = this.cropImg.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob1 = this.b64toBlob(realData, contentType);
      console.log("blob1 :>> ", blob1);
      this.img_details.size = blob1.size;
      console.log("this.img_details :>> ", this.img_details);
      this.onFileUpload(blob1, this.filename);
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    onFileUpload: function(image, filename) {
      //   let loader = this.$loading.show();

      let formData = new FormData();
      formData.append("image", image, filename);
      formData.append("imagePath", "Gallery Image");
      formData.append("height", this.img_details.height);
      formData.append("width", this.img_details.width);
      formData.append("size", this.img_details.size);

      // formData.append("imagePath", PosterItem.image_setting_static_path);
      MasterService.GlobalUploadImage(formData)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            // this.MovieContentContainer[MovieContentIndex].moviePosters[
            //   PosterIndex
            // ].image_setting_path = data.path;
            this.onSetImagePath(data);
            this.galleryId = data.galleryId;
            this.$bvModal.hide("imagecropper");
            this.$toasted.show(data.message);
            this.getGalleryImages();
            this.image_name = this.tempImageName;
          } else {
            data["message"] && data["message"]["message"]
              ? this.$toasted.show(data.message.message)
              : this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
          }
        })
        .catch(this._CatchError);
      // .finally(() => {
      //   setTimeout(() => loader.hide(), 1000);
      // });
    },
    onSetImagePath: function(data, MovieContentIndex, PosterIndex) {
      //   let Obj = this.gallery_image;
      //   console.log("Obj :>> ", Obj);
      //   let _Obj = {
      //     ...Obj,
      //     image_setting_path: data.path
      //   };
      //   Vue.set(this.gallery_image, _Obj);
      this.gallery_image.image_setting_path = data.path;
      console.log("this.gallery_image :>> ", this.gallery_image);
    },
    openImageModal: function(image_name, image_path) {
      this.tempModalImagePath = image_path;
      this.tempModalImageName = image_name;
      this.$refs["preview-modal"].show();
    },
    hideCropperModal: function() {
      this.$bvModal.hide("imagecropper");
    }
  }
};
</script>

<style>
.image-gallery-table .image-placeholder {
  width: 75px;
  height: 75px;
  border-radius: 3px;
  overflow: hidden;
  border: 1px solid #fafafa;
  background-color: #f3f3f3;
}

.image-gallery-table .image-placeholder img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.image-gallery-table td {
  vertical-align: top;
  font-weight: normal !important;
  font-size: 14px;
}

.image-gallery-table th:last-child {
  padding-right: 50px;
}
.image-gallery-table th:last-child,
.image-gallery-table td:last-child {
  text-align: right;
}

.btn-modal-close-custom {
  top: 2.5px;
  right: 10px;
  font-size: 40px;
  position: absolute;
  z-index: 11;
}

#imagecropper .btn-clearDate {
  margin-top: -10px;
  margin-right: -10px;
  font-size: 19px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ImageGallery/viewImages.vue